/** Shared ag-grid options aligned to Inbound Planning wireframe */

/** Single-line row height (Ship to is ID only). */
export const PG_GRID_ROW_HEIGHT = 40;
export const PG_GRID_HEADER_HEIGHT = 38;

export const pgDefaultColDef = {
  sortable: false,
  resizable: true,
  suppressMovable: true,
  suppressMenu: true,
  suppressHeaderMenuButton: true,
  wrapText: false,
  autoHeight: false,
  cellClass: "pg-grid-cell",
  headerClass: "pg-grid-header-cell",
};

/** Wireframe: row checkboxes only — blank header cell (no select-all). */
export const pgRowCheckboxColDef = {
  checkboxSelection: true,
  headerCheckboxSelection: false,
  headerName: "",
  width: 32,
  minWidth: 32,
  maxWidth: 32,
  suppressMenu: true,
  suppressHeaderMenuButton: true,
  resizable: false,
  sortable: false,
  lockPosition: true,
  headerClass: "pg-grid-header-cell pg-grid-header-cell--select",
  cellClass: "pg-grid-cell pg-grid-cell--select",
};

export const pgGridOptions = {
  rowHeight: PG_GRID_ROW_HEIGHT,
  headerHeight: PG_GRID_HEADER_HEIGHT,
  suppressCellFocus: true,
  enableCellTextSelection: true,
  ensureDomOrder: true,
  animateRows: false,
  pagination: false,
  domLayout: "normal",
};
